// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__nnN_q","name":"ConsentHeader_name__1PcHi","birthday":"ConsentHeader_birthday__154qQ","skeleton":"ConsentHeader_skeleton__3JSt8"};